import React, {Component} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import {validateComponent, validateField} from "../../../common/validation";
import Select from"../../../local_node_modules/react-select"
import ReferenceModal from "./ReferenceModal";
import {deepCopyObject} from "../../../helper/helper";
import AutoCompleteList from "../../../components/AutoCompleteList";
import {request} from "../../../helper/APIUtils";
import {VirtualHost} from "../../../constants";

class CustomerCommercialInfo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			error: {},
			filteredTaxOffices: [],
			commercialSoftwares: []
		};

		this.validateField = this.validateField.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.onCityChange = this.onCityChange.bind(this);
		this.onCommercialSoftwareChange = this.onCommercialSoftwareChange.bind(this);
		this.saveCommercialSoftware = this.saveCommercialSoftware.bind(this);
	}

	componentDidMount() {
		let commercialSoftware = this.props.customer.commercialSoftware;
		if (isNaN(commercialSoftware) && commercialSoftware !== null) {
			for (let i = 0; i < this.props.commercialSoftwares.length; i++) {
				if (commercialSoftware === this.props.commercialSoftwares[i].name)
					commercialSoftware = this.props.commercialSoftwares[i].recordId;
			}
		}
		let city = this.props.customer.city;
		let filteredTaxOffices = this.props.taxOffices.filter(to => to.city === city);
		this.setState({
			city,
			filteredTaxOffices,
			commercialSoftware: commercialSoftware,
			commercialSoftwares: this.props.commercialSoftwares
		})
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
		let value = e.target.value;

		let result = validateField(rule, boundary, value);
		let error = this.state.error;

		error = Object.assign(error, {[id]: result});

		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	onCityChange(e) {
		let taxOffices = this.props.taxOffices;
		let filteredTaxOffices = taxOffices.filter(to => to.city === e.value);
		this.props.onChangeCustomerCity(e.value);

		this.setState({city: e.value, filteredTaxOffices})
	}

	selectStyle(item) {
		let error = deepCopyObject(this.state.error);
		if (error[item] === undefined || error[item].valid) {
			return null;
		} else {
			return {backgroundColor: '#f8f8f8', borderColor: '#ffcfcf'}
		}
	}

	onCommercialSoftwareChange(e) {
		let commercialSoftwares = deepCopyObject(this.state.commercialSoftwares);
		let newId = commercialSoftwares[commercialSoftwares.length - 1].recordId;
		if (e.value === "0") {
			let newItem = {};
			newItem.recordId = newId + 1;
			newItem.name = e.label;
			this.saveCommercialSoftware(newItem);
			commercialSoftwares.push(newItem);
			this.setState({commercialSoftwares});
		}
		let commercialSoftware = e.value === "0" ? newId + 1 : e.value;
		this.setState({commercialSoftware});
		this.props.onCommercialSoftwareChange(e);
	}

	saveCommercialSoftware(commercialSoftware) {
		let params = {
			url: "/customer/saveCommercialSoftware",
			method: "post",
			data: commercialSoftware
		};
		request(params)
			.then({
			}).catch({
		});
	}

	render() {
		return (
			<div className="col-sm-12">
				<div className="col-sm-12 " style={{marginTop: '-15px'}}>
					<div className=" row">

						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label className="col-form-label">Ver. Dairesi *</label>
							</div>
							<div className="col-sm-3">
								<div className={"form-group" + this.validateClass('tTaxOffice')} style={{wordWrap: 'normal'}}>
									<Select
										clearable={false}
										className="select-control"
										name="taxOffice"
										id="tTaxOffice"
										onBlur={() => this.validateField(
											{
												target: {
													id: "tTaxOffice",
													dataset: {vdata: "required", vlength: "1,45"},
													value: this.state.city
												}
											})}
										inputProps={{vdata: "required", vlength: "1,45"}}
										ref="tTaxOffice"
										value={this.state.city}
										placeholder="Seçiniz..."
										style={this.selectStyle('tTaxOffice')}
										onChange={(e) => this.onCityChange(e)}
										options={this.props.cities.map(city => ({
											value: city.cityName,
											label: city.cityName
										}))}
									/>
									{this.validateMessage('tTaxOffice') !== "" &&
									<UncontrolledTooltip placement="right" target="tTaxOffice" delay={0}>
										{this.validateMessage("tTaxOffice")}
									</UncontrolledTooltip>}
								</div>
							</div>

							<div className="col-sm-5" style={{maxWidth: "none"}}>
								<div className={"form-group" + this.validateClass('tTaxOffice')}>
									<Select
										clearable={false}
										className="select-control"
										name="taxOffice"
										id="tTaxOffice"
										onBlur={() => this.validateField(
											{
												target: {
													id: "tTaxOffice",
													dataset: {vdata: "required", vlength: "1,255"},
													value: this.props.customer.taxOffice
												}
											})}
										inputProps={{vdata: "required", vlength: "1,255"}}
										ref="tTaxOffice"
										value={this.props.customer.taxOffice}
										placeholder="Seçiniz..."
										style={this.selectStyle('tTaxOffice')}
										onChange={(e) => this.props.onTaxOfficeChange(e)}
										options={this.state.filteredTaxOffices.map(to => ({
											value: to.vdName,
											label: to.vdName
										}))}
									/>
									{this.validateMessage('tTaxOffice') !== "" &&
									<UncontrolledTooltip placement="right" target="tTaxOffice" delay={0}>
										{this.validateMessage("tTaxOffice")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>


						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label className="col-form-label">Mersis No</label>
							</div>
							<div className="col-sm-8" style={{maxWidth: "none"}}>
								<div className="form-group">
									<input className="form-control"
										   maxLength="16"
										   type="text"
										   name="mersisNo"
										   id="tMersisNo"
										   value={this.props.customer.mersisNo}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-12 ">
					<div className=" row">

						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label className="col-form-label">{VirtualHost.conf.resourcePrefix === "togb" ? "Ticaret Sicil No" :"Oda Kayıt Numarası"}</label>
							</div>
							<div className="col-sm-8 form-group">
								<input className="form-control"
									   type="text"
									   name="ticaretSicilNo"
									   value={this.props.customer.ticaretSicilNo}
									   onChange={(e) => this.props.onChangeCustomer(e)}/>
							</div>
						</div>

						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label className="col-form-label">{VirtualHost.conf.resourcePrefix === "togb" ? "Ticaret Odası" :"Kayıtlı Olduğu Oda"}</label>
							</div>
							<div className="col-sm-8">
								<div className="form-group">
									<input className="form-control"
										   type="text"
										   name="commerceChamber"
										   id="tCommerceChamber"
										   value={this.props.customer.commerceChamber}
										   onChange={(e) => this.props.onChangeCustomer(e)}/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-12 ">
					<div className=" row">

						<div className="col-sm-6 row">
							<div className="col-sm-4">
								<label className='col-form-label'>Ticari Uygulama</label>
							</div>
							<div className="col-sm-8">
								<AutoCompleteList name={"Ticari Uygulama"}
												  useUpperCase={true} onlyLabel={false} allowNew={true}
												  list={this.state.commercialSoftwares.map(cs => ({
													  value: cs.recordId,
													  label: cs.name
												  }))}
												  value={this.state.commercialSoftware}
												  onChange={e => this.onCommercialSoftwareChange(e)}
												  placeholder="Seçiniz veya Yazınız"
								/>
								{/*<Select*/}
								{/*	clearable={false}*/}
								{/*	className="select-control"*/}
								{/*	name="commercialSoftware"*/}
								{/*	id="tCommercialSoftware"*/}
								{/*	ref="tCommercialSoftware"*/}
								{/*	value={this.state.commercialSoftware}*/}
								{/*	placeholder="Seçiniz..."*/}
								{/*	onChange={(e) => this.onCommercialSoftwareChange(e)}*/}
								{/*	options={this.props.commercialSoftwares.map(cs => ({*/}
								{/*		value: cs.recordId,*/}
								{/*		label: cs.name*/}
								{/*	}))}*/}
								{/*/>*/}
							</div>
						</div>
					</div>
				</div>

				{(this.props.partners && this.props.partners.length > 0) &&
				<div className="col-sm-12" style={{marginTop: '20px'}}>
					<ReferenceModal customerReferences={this.props.customer.customerReferences}
									partners={this.props.partners}
									customerData={{vknTckn: this.props.customer.vknTckn, formattedName: this.props.customer.formattedName,
										givenName: this.props.customer.givenName, familyName: this.props.customer.familyName}}
									addNewCustomerReference={this.props.addNewCustomerReference}
									deleteCustomerReference={this.props.deleteCustomerReference}
									clearCustomerReferences={this.props.clearCustomerReferences}
									setReferencesToInitialState={this.props.setReferencesToInitialState}
									fieldsDisabled={this.props.fieldsDisabled}/>
				</div>}
			</div>
		)
	}
}

export default CustomerCommercialInfo;